import script from "./MPTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./MPTabla.vue?vue&type=script&setup=true&lang=js"

import "./MPTabla.vue?vue&type=style&index=0&id=6ce89fb5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce89fb5"]])

export default __exports__